"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * Created by wqw on 2017/10/27.
 */

/* eslint-disable */
var has = function has() {};

if (!has('rs-has-api')) {
  var isBrowser = typeof window !== 'undefined' && typeof location !== 'undefined' && typeof document !== 'undefined' && window.location === location && window.document === document,
      agent = navigator.userAgent.toLowerCase(),
      global = function () {
    return this;
  }(),
      doc = isBrowser && document,
      element = doc && doc.createElement('div'),
      cache = module.config && module.config() || {};

  has = function has(name) {
    return typeof cache[name] === 'function' ? cache[name] = cache[name](global, doc, element) : cache[name];
  };

  has.cache = cache;

  has.add = function (name, test, now, force) {
    (typeof cache[name] === 'undefined' || force) && (cache[name] = test);
    return now && has(name);
  };
}

if (has('host-browser')) {
  // Common application level tests
  has.add('dom-addeventlistener', !!document.addEventListener); // Do the device and browser have touch capability?

  has.add('touch', 'ontouchstart' in document || 'onpointerdown' in document && navigator.maxTouchPoints > 0 || window.navigator.msMaxTouchPoints); // Touch events support

  has.add('touch-events', 'ontouchstart' in document);
  has.add('pointer-events', 'pointerEnabled' in window.navigator ? window.navigator.pointerEnabled : 'PointerEvent' in window);
  has.add('MSPointer', window.navigator.msPointerEnabled);
  has.add('touch-action', has('touch') && has('pointer-events')); // I don't know if any of these tests are really correct, just a rough guess

  has.add('device-width', screen.availWidth || innerWidth);
  var form = document.createElement('form');
  has.add('dom-attributes-explicit', form.attributes.length === 0); // W3C

  has.add('dom-attributes-specified-flag', form.attributes.length > 0 && form.attributes.length < 40); // IE8

  has.add('_isIE', /msie ([\d.]+)/.test(agent));
  has.add('_isIE6', has('_isIE') && /msie 6./.test(agent));
  has.add('_isIE7', has('_isIE') && /msie 7./.test(agent));
  has.add('_isIE8', has('_isIE') && /msie 8./.test(agent));
}

has.clearElement = function (element) {
  element.innerHTML = '';
  return element;
};

var _default = has;
exports["default"] = _default;